import { ITableSort } from 'src/utils/SortUtils';
import {IReduxState} from '../IReduxState';

export const selectVirtualizedTableRollback = (state: IReduxState): boolean =>
  state.dynTable.dynTabelRollback;

export const selectVirtualizedTableReload = (state: IReduxState): boolean =>
  state.dynTable.dynTableReload;

export const selectOptionTableSort = (state: IReduxState): ITableSort =>
  state.dynTable.optionTableSort;

export const selectVirtualizedTableSelectedIdList = (state: IReduxState): string[] =>
  state.dynTable.dynTableSelectedIdList;

export const selectOptionBasicTableSort = (state: IReduxState): ITableSort =>
  state.dynTable.optionBasicTableSort;



// WEBPACK FOOTER //
// ./src/redux/selectors/dynTableSelectors.ts